import { Phone, MessageSquare, CalendarCheck } from "lucide-react";
import { motion } from "framer-motion";
import { WA_MESSAGE } from "../data/site";
import { digitsOnly } from "../lib/api";

export const StickyMobileBar = ({ phone, whatsapp, onEnquire }) => (
  <div
    data-testid="sticky-mobile-bar"
    className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-[#EAF5D6] border-t border-[#84CC16]/30 shadow-[0_-8px_30px_rgba(63,98,18,0.20)] grid grid-cols-3"
  >
    <a
      data-testid="sticky-call-btn"
      href={`tel:${phone}`}
      className="flex items-center justify-center gap-2 py-4 text-[#3F6212] text-[13px] font-sub font-medium active:bg-[#DCECC0]"
    >
      <Phone size={16} /> Call
    </a>
    <a
      data-testid="sticky-whatsapp-btn"
      href={`https://wa.me/${digitsOnly(whatsapp)}?text=${encodeURIComponent(WA_MESSAGE)}`}
      target="_blank" rel="noopener noreferrer"
      className="flex items-center justify-center gap-2 py-4 text-[#3F6212] text-[13px] font-sub font-medium border-x border-[#84CC16]/25 active:bg-[#DCECC0]"
    >
      <MessageSquare size={16} /> WhatsApp
    </a>
    <button
      data-testid="sticky-enquire-btn"
      onClick={onEnquire}
      className="flex items-center justify-center gap-2 py-4 text-[#365314] bg-gradient-to-r from-[#84CC16] to-[#65A30D] text-[13px] font-sub font-semibold active:brightness-95"
    >
      <CalendarCheck size={16} /> Enquire
    </button>
  </div>
);

export const WhatsAppFloat = ({ whatsapp }) => (
  <motion.a
    data-testid="whatsapp-float-btn"
    href={`https://wa.me/${digitsOnly(whatsapp)}?text=${encodeURIComponent(WA_MESSAGE)}`}
    target="_blank" rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    className="fixed bottom-20 md:bottom-6 right-4 md:right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_12px_30px_-8px_rgba(37,211,102,0.6)] hover:bg-[#1EBE57] hover:scale-105 active:scale-95 transition-all duration-300"
  >
    <MessageSquare size={24} fill="currentColor" strokeWidth={0} />
  </motion.a>
);
